







































































import Vue from "vue";
import S4Bluetooth from "@/services/bluetoothService";
export default Vue.extend({
  name: "App",
  data: () => ({
    S4: S4Bluetooth,
    tab: null,
    isBluetoothOn: true,
  }),
  async mounted() {
    this.$vuetify.theme.dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.isBluetoothOn = await this.S4.isEnabled();
    this.S4.startEnabledNotifications((isOn) => {
      this.isBluetoothOn = isOn;
      if(!isOn){
        if(this.S4.device){
          this.S4.device = null;
          this.S4.isSubscribed = false;
          this.S4.isAuthtenticated = false;
          this.S4.disconnect();
          this.$router.replace("/");
        }
      }
    });
  },
  methods: {
    async disconnect() {
      if(confirm("Are you sure you want to disconnect from the device?")){
        await this.S4.disconnect();
        this.$router.replace("/");
      }
    },
  },
});
